var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78473 6.48243C7.68682 6.32847 7.54021 6.27647 7.36911 6.37233C6.73398 6.72783 6.14076 7.47301 5.82026 8.20887C5.75878 8.40255 5.82787 8.59376 5.97511 8.65378C5.98478 8.65773 5.99478 8.66109 6.00495 8.66382C6.17253 8.70882 6.36149 8.57798 6.42694 8.37179C6.78257 7.74673 7.2078 7.16439 7.71437 6.88078C7.84111 6.80982 7.89579 6.65754 7.78473 6.48243Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8785 3.70064C6.9949 3.70064 3.84664 6.84891 3.84664 10.7325C3.84664 14.6161 6.9949 17.7643 10.8785 17.7643C14.7621 17.7643 17.9103 14.6161 17.9103 10.7325C17.9103 6.84891 14.7621 3.70064 10.8785 3.70064ZM2.94434 10.7325C2.94434 6.35058 6.49658 2.79834 10.8785 2.79834C15.2604 2.79834 18.8126 6.35058 18.8126 10.7325C18.8126 12.8356 17.9944 14.7476 16.6588 16.1675L21.0545 20.5632L20.4165 21.2012L16.0042 16.7889C14.6216 17.9603 12.8325 18.6666 10.8785 18.6666C6.49658 18.6666 2.94434 15.1144 2.94434 10.7325Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSearchIcon);
export default __webpack_public_path__ + "static/media/MenuSearchIcon.bbcb566d.svg";
export { ForwardRef as ReactComponent };